import { useExperiment } from '@hungryroot/experiments';
import { Paragraph } from '@hungryroot/ramen';
import { useCustomerSelfAddress } from '../../../../api/v2/customers/self/address/get/useCustomerSelfAddress';
import styles from './Disclaimer.module.css';

const disclaimerDetailStates = [
  'CA',
  'CO',
  'CT',
  'DC',
  'HI',
  'ID',
  'IL',
  'NM',
  'NY',
  'NC',
  'OR',
  'TN',
  'VA',
  'WI',
];

function getShowDisclaimerDetail(
  shippingState: string | undefined,
  billingState: string | undefined
) {
  const shippingStateIsValid =
    shippingState && disclaimerDetailStates.includes(shippingState);
  const billingStateIsValid =
    billingState && disclaimerDetailStates.includes(billingState);

  return shippingStateIsValid || billingStateIsValid;
}

interface Props {
  testid?: string;
  planTotal: string;
  billingState?: string;
  className?: string;
}

export function Disclaimer(props: Props) {
  const { testid, planTotal, billingState, className } = props;
  const { data } = useCustomerSelfAddress();
  const { state: shippingState } = data || {};

  const showDetail = getShowDisclaimerDetail(shippingState, billingState);

  const exp164 = useExperiment(164);

  const inExp164Variant = exp164 !== undefined && exp164 > 0;

  const flexCreditMessaging =
    'I understand that my weekly price may change depending on my order, including as a result of Hungryroot’s SmartCart™ technology that will adjust and recommend more personalized items based on my ordering history. ';

  return showDetail ? (
    <Paragraph
      className={`${styles.disclaimer} ${className}`}
      variant="caption"
      testid={testid}
    >
      By placing my order, I agree to the{' '}
      <a
        href="https://www.hungryroot.com/terms/"
        target="_blank"
        className={styles.link}
      >
        Terms of Service
      </a>{' '}
      &{' '}
      <a
        href="https://www.hungryroot.com/privacy/"
        target="_blank"
        className={styles.link}
      >
        Privacy Policy
      </a>{' '}
      and, unless I cancel, I will be charged the auto-renew price of{' '}
      <span data-testid={`${testid}-plan-total`}> ${planTotal}</span> per
      delivery following my discount, plus applicable state and local taxes.{' '}
      {inExp164Variant ? flexCreditMessaging : ''}I can skip a delivery or
      cancel my subscription at any time.
    </Paragraph>
  ) : (
    <Paragraph
      className={`${styles.disclaimer} ${className}`}
      variant="caption"
      testid={testid}
    >
      By placing my order, I agree to the{' '}
      <a
        href="https://www.hungryroot.com/terms/"
        target="_blank"
        className={styles.link}
      >
        Terms of Service
      </a>{' '}
      &{' '}
      <a
        href="https://www.hungryroot.com/privacy/"
        target="_blank"
        className={styles.link}
      >
        Privacy Policy
      </a>
      .
    </Paragraph>
  );
}
